import { Input, InputRef, Space, Typography } from "antd";
import { DefaultTFuncReturn } from "i18next";
import { ChangeEventHandler, forwardRef, Ref } from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

type Props = {
  label?: string | DefaultTFuncReturn;
  type: string;
  name?: string;
  value?: any;
  handleChange?: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string | undefined;
  disabled?: boolean;
  infoText?: string;
  inputError?: boolean;
  inputMode?: "text" | "search" | "email" | "tel" | "url" | "none" | "numeric" | "decimal" | undefined;
  optional?: boolean;
};

const AuthInputComponent = forwardRef<InputRef, Props>(
  ({ label, type, name, value, handleChange, placeholder, inputMode, disabled, infoText, inputError, optional }, ref: Ref<InputRef>) => {
    const { t } = useTranslation();

    return (
      <Space className="w-full gap-6" direction="vertical">
        {label && (
          <Space className="w-full justify-content-between" direction="horizontal">
            <div>
              <Typography.Text className="authInputLabel">{label}</Typography.Text>
              {optional && <Typography.Text className="authOptionalLabel">({t("optional")})</Typography.Text>}
            </div>
            {infoText && <Typography.Text className="authInfoText">{infoText}</Typography.Text>}
          </Space>
        )}
        {type === "password" ? (
          <Input.Password
            className="authInput"
            type={type}
            name={name}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            ref={ref}
          />
        ) : (
          <Input
            className={`authInput ${inputError ? "input-error" : ""}`}
            type={type}
            name={name}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            inputMode={inputMode}
            disabled={disabled}
            ref={ref}
          />
        )}
      </Space>
    );
  }
);

export default AuthInputComponent;
